import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import MealCard from "./MealCard";
import GlobalContext from "../../context/GlobalContext";
import bgImg from "../../assets/micasabackground.jpg";

const Meals = () => {
  const context = useContext(GlobalContext);
  const params = useParams();
  console.log("[Meals] params", params);
  let category = null;
  params.category = params.category.split("?")[0] // Ensure category is defined

  if (context.menu) {
    category = context.menu[params.type].categories.find(
      (cat) => cat.categoryId === params.category
    );
  }

  const renderItems = () => {
    console.log("renderItems");
    if(!category.items){
      console.log("braneee fix",context.configuration.table)
      window.location.href = "/" + context.configuration.restaurantDetails.username + "/" + context.configuration.table
    }
    return category.items.map((m) => <MealCard key={m.id} meal={m} />);
  };

  const getBackgroundStyle = () => {
    let style = { paddingTop: 60, filter: context.blur };
    // if(context.configuration.restaurantDetails.parallaxUploaded !== "" && context.configuration.restaurantDetails.parallaxUploaded.startsWith("http")){
    //   console.log("vlagaa")
    //   style.backgroundImage = `url(${context.configuration.restaurantDetails.parallaxUploaded})`;
    //   /* Set a specific height */
    //   style.minHeight= "100%";
    //   /* Create the parallax scrolling effect */
    //   style.backgroundAttachment= "fixed";
    //   style.backgroundPosition= "center";
    //   style.backgroundRepeat= "no-repeat";
    //   style.backgroundSize= "cover";
    // }
    return style;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    //console.log("brane")
    //window.scrollTo({top: 0, behavior: 'smooth'});
  }, [category]);

  return (
    <>
      <div className="scroll-content" style={getBackgroundStyle()}>
        {category && renderItems()}
      </div>
    </>
  );
};

export default Meals;
